import { Menu } from "@design-system/Menu/Menu.lib";
import { AccountSettingsItems } from "./AccountSettingsItems";
import { WorkspaceSettingsItems } from "./WorkspaceSettingsItems";
import { ReferralDrawerTrigger } from "./ReferralDrawerTrigger";

export const MainViewUserDropdownItems: React.FC = () => (
    <>
        <AccountSettingsItems />
        <ReferralDrawerTrigger />
        <Menu.Separator />
        <WorkspaceSettingsItems />
    </>
);
